import React from 'react'
import HireButton from './HireButton'

export default function HomeContent() {
  return (
    <div className="home__left">
      <h1 className="home__title">Hi! I'm Hamza.</h1>
      <h3 className="home__subtitle">UI/UX Desinger &amp; Developer</h3>
      <p className="home__text">
        I will create clean, modern, attractive and clean websites &amp;
        mockups.
      </p>
      <HireButton />
    </div>
  )
}
